import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { NotFoundComponent } from './layout/components/not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./core/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.dashboardRoutes)
      },
      {
        path: 'lead',
        loadChildren: () => import('./features/lead/lead.routes').then(m => m.leadRoutes)
      },
      {
        path: 'deal',
        loadChildren: () => import('./features/deal/deal.routes').then(m => m.dealRoutes)
      },
      {
        path: 'task',
        loadChildren: () => import('./features/task/task.routes').then(m => m.taskRoutes)
      },
      {
        path: 'task-list',
        loadChildren: () => import('./features/task/task-list.routes').then(m => m.taskListRoutes)
      },
      {
        path: 'prodotti',
        loadChildren: () => import('./features/prodotti/prodotti.routes').then(m => m.prodottiRoutes)
      },
      {
        path: 'utenti',
        loadChildren: () => import('./features/utenti/utenti.routes').then(m => m.utentiRoutes)
      },
      {
        path: 'venditori',
        loadChildren: () => import('./features/venditori/venditori.routes').then(m => m.venditoriRoutes)
      },
      {
        path: 'impostazioni',
        loadChildren: () => import('./features/impostazioni/impostazioni.routes').then(m => m.impostazioniRoutes)
      },
      { path: '**', component: NotFoundComponent }
    ]
  },
  { path: '**', component: NotFoundComponent }
];
